import { render, staticRenderFns } from "./PolTypeCls.vue?vue&type=template&id=053ab03f&"
import script from "./PolTypeCls.vue?vue&type=script&lang=js&"
export * from "./PolTypeCls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports